<template>
  <b-form-row>
    <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="title">
      <NaturezaDespesaList :prefix="prePrefix" @onDblClickNaturezaDespesa="naturezaDespesaSelect"
        :fromItemBemPermanenteList="fromItemBemPermanenteList" />
    </b-modal>

    <lg-form-input-finder :disabled="disabled" :value="computedValue" @input="updateValue" fieldDescription="descricao" :label="label"
      invalidFeedback="Natureza de Despesa deve ser informada!" description="" @handleClean="handleClean">
      <template #prepend>
        <b-button :disabled="disabled" @click="show" class="btn-input-finder" pressed>
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import NaturezaDespesaList from "@/modules/cadastros/natureza-despesa/NaturezaDespesaList.vue"

export default {
  components: { LgFormInputFinder, NaturezaDespesaList },
  props: {
    id: String,
    prefix: Array,
    value: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    fromItemBemPermanenteList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: this.value || {},
    }
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue
      },
      set(newValue) {
        this.internalValue = newValue
      },
    },
    prePrefix() {
      return [...this.prefix]
    },

    updatedPrefix() {
      return [...this.prefix, "Natureza de Despesa"]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
  },
  methods: {
    show() {
      this.$bvModal.show(this.id)
    },
    updateValue(newValue) {
      this.computedValue = newValue
      this.$emit('input', newValue)
    },
    handleClean() {
      this.computedValue = {}
      this.$emit('input', {})
    },
    naturezaDespesaSelect(item) {
      this.computedValue = item
      this.$emit('input', item)
      this.$bvModal.hide(this.id)
    },
  },
}
</script>
